import apiClient from "../../../helpers/apiClient";

export async function completeReservationCheckIn(reservationId, body) {
    const { data } = await apiClient.post(`/api/reservation/check-in/${reservationId}`, body);

    if (!data?.success) {
        throw new Error(data?.message || "Failed to complete check-in");
    }

    // After insurance has started — TeqMobility rejects coverage if pickup was set on the earlier PATCH.
    await apiClient.patch(`/api/reservation/${reservationId}`, { isCarPickedUp: true });

    return data?.data || null;
}

export async function registerCheckInCashPayment(reservationId, amount, agreementDocUrl) {
    const normalizedAmount = parseFloat(Number(amount).toFixed(2));

    return completeReservationCheckIn(reservationId, {
        agreementDocUrl,
        ...(normalizedAmount > 0 ? { paymentMethod: "cash", amount: normalizedAmount } : {}),
    });
}
